"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { BoundedPortal } from '../FloatingPortalBoundary/index.mjs';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';
import { Root, Trigger, Positioner, Content, Arrow, ArrowTip } from '../../ui-kit/styled/tooltip.mjs';

const tooltipRecipe = tv({
  slots: withSlotScopeClasses("tooltip", {
    content: "shadow-none font-normal",
    "arrow-tip": ""
  }),
  variants: {
    type: {
      default: {
        content: "bg-neutral-3 rounded text-fg-default",
        "arrow-tip": "!bg-neutral-3"
      },
      dropdown: {
        content: "bg-black rounded-xl text-white font-medium px-2 py-1.5 max-w-full",
        "arrow-tip": "!bg-black"
      }
    }
  },
  defaultVariants: {
    type: "default"
  }
});
const Tooltip = forwardRef(
  ({
    tooltip,
    placement = "right",
    delayToShow = 300,
    delayToHide = 50,
    offset = [0, 6],
    className,
    children,
    disabled,
    withArrow = true,
    type = "default",
    usePortal = false,
    id
  }, ref) => {
    const styles = tooltipRecipe({ type });
    const [crossAxis, mainAxis] = offset;
    return /* @__PURE__ */ jsxs(
      Root,
      {
        lazyMount: true,
        openDelay: delayToShow,
        closeDelay: delayToHide,
        positioning: {
          offset: {
            mainAxis,
            crossAxis
          },
          placement
        },
        disabled,
        ids: {
          trigger: id
        },
        children: [
          /* @__PURE__ */ jsx(Trigger, { asChild: true, children }),
          /* @__PURE__ */ jsx(BoundedPortal, { usePortal, children: /* @__PURE__ */ jsx(Positioner, { className, ref, children: /* @__PURE__ */ jsxs(Content, { className: styles.content(), children: [
            withArrow && /* @__PURE__ */ jsx(
              Arrow,
              {
                style: {
                  // https://github.com/cschroeter/park-ui/issues/411
                  "--arrow-size": "0.5rem"
                },
                children: /* @__PURE__ */ jsx(ArrowTip, { className: styles["arrow-tip"]() })
              }
            ),
            tooltip
          ] }) }) })
        ]
      }
    );
  }
);

export { Tooltip };
